import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const featureGridSchema = {
    componentId: "FeatureGrid",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        {
            key: "body",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Body",
            type: "textarea",
        },
        { key: "columns", label: "Columns (2-4)", type: "number" },
    ],
    mediaSlots: [],
    repeatSlots: [
        {
            key: "items",
            label: "Features",
            itemLabel: "Feature",
            scalarSlots: [
                { key: "title", ...TITLE_COPY_LIMITS, label: "Title", type: "text" },
                {
                    key: "description",
                    ...DESCRIPTION_COPY_LIMITS,
                    label: "Description",
                    type: "textarea",
                },
            ],
            mediaSlots: [
                {
                    key: "icon",
                    label: "Icon",
                    targets: [{ width: 240, height: 240, aspectRatio: "1:1" }],
                },
            ],
        },
    ],
};
//# sourceMappingURL=feature-grid.js.map